export default "/images/vendor/@coreui/icons/svg/flag/cif-fm.svg?cfe3562bac84ce6ebc986a4621c6bb02";